export default "__VITE_ASSET__BHlJNLro__"